import React, { useEffect, useState } from 'react';
import styled from '@emotion/styled';

const TopScrollBarWrapperDiv = styled.div`
  overflow: scroll hidden;
  height: 5px;
  scrollbar-color: #071b31 black;
  scrollbar-width: thin;
  &::-webkit-scrollbar {
    height: 20px !important;
    display: block !important;
  }
  &::-webkit-scrollbar-thumb {
    background-color: #071b31;
    border-radius: 10% 10% 10% 10%;
  }
  &::-webkit-scrollbar-track {
    background: #cccccc;
}
`;
const TopScrollBar = styled.div`
  height: 20px !important;
  display: block !important;
  &::-webkit-scrollbar {
    height: 20px !important;
    display: block !important;
  }
`;

const TopScrollBarWrapper = () => {
  const [scrollWrapperWidth, setScrollWrapperWidth] = useState(0);
  const getAndSetWidth = (tableRes, table, topScrollWrap, scrollBar) => {
    const responsiveTable = tableRes;
    if (responsiveTable) {
      const tableSet = table;
      const topScrollWrapper = topScrollWrap;
      const topScrollBar = scrollBar;
      const tableResponsiveWidth = `${responsiveTable?.clientWidth}px`;
      const tableWidth = `${tableSet.clientWidth}px`;
      setScrollWrapperWidth(responsiveTable.clientWidth);
      topScrollWrapper.style.width = tableResponsiveWidth;
      topScrollBar.style.width = tableWidth;
      responsiveTable.addEventListener('scroll', (event) => {
        topScrollWrap.scroll(event.target.scrollLeft, 0);
      });
    }
  };

  useEffect(() => {
    const tableResponsive = document.querySelectorAll('[class*="ResponsiveTableWrapper"]')[0];
    const table = document.querySelectorAll('[class*="TableStyled"]')[0];
    const tableTopScrollWrapper = document.getElementById('topScrollWrapper');
    const tableTopScrollBar = document.getElementById('topScrollBar');
    function handleSizing() {
      getAndSetWidth(tableResponsive, table, tableTopScrollWrapper, tableTopScrollBar);
    }
    // handles sizing on initial load
    handleSizing();
    window.addEventListener('resize', handleSizing);
    return () => {
      // window.removeEventListener('load', handleSizing);
      window.removeEventListener('resize', handleSizing);
    };
  }, [scrollWrapperWidth]);

  return (
    <TopScrollBarWrapperDiv id="topScrollWrapper">
      <TopScrollBar id="topScrollBar" />
    </TopScrollBarWrapperDiv>
  );
};

export default TopScrollBarWrapper;
